// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CbM2HpSDHvVc1hapVJra{display:flex;justify-content:space-between;margin-bottom:13px}.XjKZbWagK19DfBH9cb00{display:flex;align-items:center;gap:4px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/SummaryLine/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,6BAAA,CACA,kBAAA,CAEF,sBACE,YAAA,CACA,kBAAA,CACA,OAAA","sourcesContent":[".summaryLine {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 13px;\n}\n.lineDesc {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryLine": `CbM2HpSDHvVc1hapVJra`,
	"lineDesc": `XjKZbWagK19DfBH9cb00`
};
export default ___CSS_LOADER_EXPORT___;
